export default "__VITE_ASSET__2a2a6be1__"